import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'core-js/modules/es6.array.fill.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.array.find-index.js';
import 'core-js/modules/es6.array.slice.js';
import 'core-js/modules/es6.array.find.js';
import React__default, { useCallback, useRef, useEffect } from 'react';
import { useMultipleSelection, useSelect, useCombobox } from 'downshift';
import useCombinedRefs from '../../utils/use-combined-refs.js';
import { useCommonStuff, PortalMenu, ComplexItem } from './common.js';
import { SearchInput } from '../search-input/search-input.js';
import { Classes, Tag } from '@blueprintjs/core';
import { textPlaceholder } from '../theme/theme.js';
import { Button } from '../button/button.js';
import { Icon } from '../icon/icon.js';
import { ChevronDown20, Close16 } from '@carbon/icons-react';
import cx from 'classnames';

var _excluded = ["ref"],
    _excluded2 = ["ref"],
    _excluded3 = ["label", "selectedItems", "onSelectedItemsChange", "id", "onItemSelect", "isItemSelected", "multiSelectResults"],
    _excluded4 = ["selectedItems", "onSelectedItemsChange", "onSearchInputValueChange", "label", "id", "onItemSelect", "multiSelectResults", "clearSearchOnSelect"],
    _excluded5 = ["ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function MultiSelectInternal(_ref) {
  var _cx;

  var id = _ref.id,
      label = _ref.label,
      selectedItems = _ref.selectedItems,
      placeholder = _ref.placeholder,
      getIcon = _ref.getIcon,
      getItemTooltip = _ref.getItemTooltip,
      _ref$multilineItems = _ref.multilineItems,
      multilineItems = _ref$multilineItems === void 0 ? true : _ref$multilineItems,
      hookResults = _ref.hookResults,
      commonStuffResults = _ref.commonStuffResults,
      searchInput = _ref.searchInput,
      multiSelectResults = _ref.multiSelectResults,
      large = _ref.large,
      className = _ref.className,
      intent = _ref.intent,
      isItemSelected = _ref.isItemSelected,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? true : _ref$fill,
      disabled = _ref.disabled,
      _ref$isCombobox = _ref.isCombobox,
      isCombobox = _ref$isCombobox === void 0 ? false : _ref$isCombobox;
  useEffect(function () {
    var _commonStuffResults$u;

    // need to trigger update to popper on select change because we are always showing
    // the menu. Also, update may be undefined so catch that case (types are incorrect).
    (_commonStuffResults$u = commonStuffResults.updatePopper) === null || _commonStuffResults$u === void 0 ? void 0 : _commonStuffResults$u.call(commonStuffResults);
  }, [selectedItems, commonStuffResults.updatePopper, hookResults.isOpen]);
  var classes = cx(Classes.INPUT, Classes.TAG_INPUT, (_cx = {}, _defineProperty(_cx, Classes.ACTIVE, hookResults.isOpen), _defineProperty(_cx, Classes.LARGE, large), _defineProperty(_cx, Classes.FILL, fill), _defineProperty(_cx, Classes.DISABLED, disabled), _cx), Classes.intentClass(intent), className);

  var _multiSelectResults$g = multiSelectResults.getDropdownProps(hookResults.getToggleButtonProps({
    id: id,
    "aria-label": label,
    className: classes
  })),
      buttonRef = _multiSelectResults$g.ref,
      buttonProps = _objectWithoutProperties(_multiSelectResults$g, _excluded);

  var combinedButtonRef = useCombinedRefs(buttonRef, commonStuffResults.setReferenceElement);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", _extends({}, buttonProps, {
    ref: combinedButtonRef,
    style: {
      cursor: disabled ? "not-allowed" : "pointer"
    }
  }, commonStuffResults.targetAriaProps, {
    "aria-label": "".concat(selectedItems.length ? selectedItems : placeholder, ", ").concat(commonStuffResults.targetAriaProps["aria-label"]),
    tabIndex: disabled ? -1 : 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === "Space" || isCombobox && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
        var _buttonProps$onClick;

        (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 ? void 0 : _buttonProps$onClick.call(buttonProps, e);
      } else {
        var _buttonProps$onKeyDow;

        (_buttonProps$onKeyDow = buttonProps.onKeyDown) === null || _buttonProps$onKeyDow === void 0 ? void 0 : _buttonProps$onKeyDow.call(buttonProps, e);
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: Classes.TAG_INPUT_VALUES
  }, selectedItems.length === 0 && placeholder ? /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: textPlaceholder,
      userSelect: "none"
    }
  }, placeholder) : null, selectedItems.map(function (item, index) {
    var _multiSelectResults$g2 = multiSelectResults.getSelectedItemProps({
      selectedItem: item,
      index: index
    }),
        ref = _multiSelectResults$g2.ref,
        otherProps = _objectWithoutProperties(_multiSelectResults$g2, _excluded2);

    var IconIncoming = getIcon === null || getIcon === void 0 ? void 0 : getIcon(item);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      key: commonStuffResults.getItemId(item),
      intent: "primary",
      onRemove: disabled ? undefined : function (e) {
        e.stopPropagation();
        multiSelectResults.removeSelectedItem(item);
      },
      elementRef: ref,
      icon: IconIncoming && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null))
    }, otherProps), commonStuffResults.itemToString(item));
  })), !disabled && /*#__PURE__*/React__default.createElement(Button, {
    className: "vds-clear-button",
    minimal: true,
    disabled: selectedItems.length === 0,
    icon: selectedItems.length === 0 ? ChevronDown20 : Close16,
    onClick: function onClick(e) {
      e.stopPropagation();
      multiSelectResults.reset();
    },
    style: selectedItems.length === 0 ? {
      cursor: "inherit"
    } : undefined
  })), !disabled && /*#__PURE__*/React__default.createElement(PortalMenu, _extends({
    getMenuProps: commonStuffResults.getMenuPropsEnhancer(hookResults.getMenuProps),
    isOpen: hookResults.isOpen
  }, commonStuffResults.portalMenuProps, {
    searchInput: searchInput
  }), commonStuffResults.items.map(function (item, index) {
    var itemProps = hookResults.getItemProps({
      item: item,
      index: index
    });
    return /*#__PURE__*/React__default.createElement(ComplexItem, _extends({
      key: commonStuffResults.getItemId(item),
      getItemText: commonStuffResults.itemToString,
      placeholder: placeholder,
      getIcon: getIcon,
      getItemTooltip: getItemTooltip,
      multilineItems: multilineItems
    }, itemProps, {
      item: item,
      index: index,
      highlightedIndex: hookResults.highlightedIndex,
      checkbox: item !== null,
      selected: isItemSelected(item)
    }));
  })));
}

function MultiSelectWithoutSearch(_ref2) {
  var label = _ref2.label,
      selectedItems = _ref2.selectedItems;
      _ref2.onSelectedItemsChange;
      var id = _ref2.id,
      onItemSelect = _ref2.onItemSelect,
      isItemSelected = _ref2.isItemSelected,
      multiSelectResults = _ref2.multiSelectResults,
      props = _objectWithoutProperties(_ref2, _excluded3);

  var allCommonStuff = useCommonStuff(_objectSpread(_objectSpread({}, props), {}, {
    label: label,
    placeholder: undefined
  }));
  var useSelectResults = useSelect(_objectSpread(_objectSpread({}, allCommonStuff.downshiftProps), {}, {
    selectedItem: null,
    onSelectedItemChange: function onSelectedItemChange(changes) {
      return onItemSelect(changes.selectedItem);
    },
    stateReducer: function stateReducer(state, action) {
      var changes = action.changes,
          type = action.type;

      switch (type) {
        case useSelect.stateChangeTypes.FunctionSelectItem:
        case useSelect.stateChangeTypes.FunctionOpenMenu:
        case useSelect.stateChangeTypes.ItemClick:
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: true,
            highlightedIndex: state.highlightedIndex
          });

        default:
          return changes;
      }
    }
  }));
  return /*#__PURE__*/React__default.createElement(MultiSelectInternal, _extends({}, props, {
    id: id,
    selectedItems: selectedItems,
    hookResults: useSelectResults,
    commonStuffResults: allCommonStuff,
    multiSelectResults: multiSelectResults,
    isItemSelected: isItemSelected
  }));
}

function MultiSelectWithSearch(_ref3) {
  var selectedItems = _ref3.selectedItems;
      _ref3.onSelectedItemsChange;
      var onSearchInputValueChange = _ref3.onSearchInputValueChange,
      label = _ref3.label,
      id = _ref3.id,
      onItemSelect = _ref3.onItemSelect,
      multiSelectResults = _ref3.multiSelectResults,
      _ref3$clearSearchOnSe = _ref3.clearSearchOnSelect,
      clearSearchOnSelect = _ref3$clearSearchOnSe === void 0 ? false : _ref3$clearSearchOnSe,
      props = _objectWithoutProperties(_ref3, _excluded4);

  var allCommonStuff = useCommonStuff(_objectSpread(_objectSpread({}, props), {}, {
    label: label,
    placeholder: undefined
  }));
  var inputElement = useRef(null);
  var useComboboxResults = useCombobox(_objectSpread(_objectSpread({}, allCommonStuff.downshiftProps), {}, {
    selectedItem: null,
    // force this since we actually ignore selected
    onSelectedItemChange: function onSelectedItemChange(changes) {
      return onItemSelect(changes.selectedItem);
    },
    onInputValueChange: function onInputValueChange(changes) {
      changes.inputValue !== undefined && onSearchInputValueChange(changes.inputValue);
    },
    stateReducer: function stateReducer(state, action) {
      var changes = action.changes,
          type = action.type;

      switch (type) {
        case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            highlightedIndex: state.highlightedIndex,
            inputValue: changes.isOpen && !clearSearchOnSelect ? state.inputValue : ""
          });

        case useCombobox.stateChangeTypes.FunctionSelectItem:
        case useCombobox.stateChangeTypes.FunctionOpenMenu:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: true,
            highlightedIndex: state.highlightedIndex,
            inputValue: clearSearchOnSelect ? "" : state.inputValue
          });

        default:
          if (changes.isOpen === false) {
            return _objectSpread(_objectSpread({}, changes), {}, {
              inputValue: ""
            });
          }

          return changes;
      }
    },
    onIsOpenChange: function onIsOpenChange(changes) {
      var _allCommonStuff$downs, _allCommonStuff$downs2;

      if (changes.isOpen) {
        // slight delay because input is hidden until opened.
        setTimeout(function () {
          var _inputElement$current;

          return (_inputElement$current = inputElement.current) === null || _inputElement$current === void 0 ? void 0 : _inputElement$current.focus();
        }, 0);
      } else {
        setTimeout(function () {
          var _allCommonStuff$refer;

          return (_allCommonStuff$refer = allCommonStuff.referenceElement) === null || _allCommonStuff$refer === void 0 ? void 0 : _allCommonStuff$refer.focus();
        }, 0);
      }

      (_allCommonStuff$downs = (_allCommonStuff$downs2 = allCommonStuff.downshiftProps).onIsOpenChange) === null || _allCommonStuff$downs === void 0 ? void 0 : _allCommonStuff$downs.call(_allCommonStuff$downs2, changes);
    }
  }));

  var _useComboboxResults$g = useComboboxResults.getInputProps(),
      inputRef = _useComboboxResults$g.ref,
      inputProps = _objectWithoutProperties(_useComboboxResults$g, _excluded5);

  var combinedInputRef = useCombinedRefs(inputRef, inputElement);
  var containerProps = useComboboxResults.getComboboxProps();
  return /*#__PURE__*/React__default.createElement("div", _extends({}, containerProps, {
    style: props.fill ? {
      width: "100%"
    } : undefined
  }), /*#__PURE__*/React__default.createElement(MultiSelectInternal, _extends({}, props, {
    id: id,
    selectedItems: selectedItems,
    hookResults: useComboboxResults,
    commonStuffResults: allCommonStuff,
    searchInput: /*#__PURE__*/React__default.createElement(SearchInput, _extends({
      ref: combinedInputRef
    }, inputProps, {
      onClearValue: function onClearValue() {
        var _inputElement$current2;

        onSearchInputValueChange("");
        (_inputElement$current2 = inputElement.current) === null || _inputElement$current2 === void 0 ? void 0 : _inputElement$current2.focus();
      }
    }, allCommonStuff.targetAriaProps, {
      isLoading: !props.loadingPlaceholderItems && props.isLoading,
      disabled: props.loadingPlaceholderItems && props.isLoading
    })),
    multiSelectResults: multiSelectResults,
    isCombobox: true
  })));
}

function MultiSelect(props) {
  // this can be removed in typescript 4.5 for better inference.
  var onSearchInputValueChange = props.onSearchInputValueChange;
  var searchInputValue = props.searchInputValue;
  var multiSelectResults = useMultipleSelection({
    selectedItems: props.selectedItems,
    onSelectedItemsChange: useCallback(function (changes) {
      return props.onSelectedItemsChange(changes.selectedItems);
    }, [props.onSelectedItemsChange]),
    itemToString: props.getItemId,
    stateReducer: function stateReducer(state, action) {
      switch (action.type) {
        case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
          // Fixing an issue in downshift where remove based on object references isn't consistent.
          var selectedItem = action.selectedItem;

          if (!selectedItem) {
            return action.changes;
          }

          var activeIndex = state.activeIndex,
              selectedItems = state.selectedItems;
          var newActiveIndex = activeIndex;
          var selectedItemIndex = selectedItems.findIndex(function (item) {
            return props.getItemId(item) === props.getItemId(selectedItem);
          });

          if (selectedItems.length === 1) {
            // Set to 0 to focus on the first item
            newActiveIndex = 0;
          } else if (selectedItemIndex === selectedItems.length - 1) {
            newActiveIndex = selectedItems.length - 2;
          }

          return _objectSpread(_objectSpread({}, action.changes), {}, {
            selectedItems: [].concat(_toConsumableArray(selectedItems.slice(0, selectedItemIndex)), _toConsumableArray(selectedItems.slice(selectedItemIndex + 1))),
            activeIndex: newActiveIndex
          });

        default:
          return action.changes;
      }
    }
  });
  var isItemSelected = useCallback(function (item) {
    var id = props.getItemId(item);
    return !!props.selectedItems.find(function (i) {
      return props.getItemId(i) === id;
    });
  }, [props.selectedItems, props.getItemId]);
  var onItemSelect = useCallback(function (item) {
    if (isItemSelected(item)) {
      multiSelectResults.removeSelectedItem(item);
    } else {
      multiSelectResults.addSelectedItem(item);
    }
  }, [isItemSelected]);

  if (onSearchInputValueChange !== undefined && searchInputValue !== undefined) {
    return /*#__PURE__*/React__default.createElement(MultiSelectWithSearch, _extends({}, props, {
      onSearchInputValueChange: onSearchInputValueChange,
      searchInputValue: searchInputValue,
      multiSelectResults: multiSelectResults,
      isItemSelected: isItemSelected,
      onItemSelect: onItemSelect
    }));
  }

  return /*#__PURE__*/React__default.createElement(MultiSelectWithoutSearch, _extends({}, props, {
    multiSelectResults: multiSelectResults,
    isItemSelected: isItemSelected,
    onItemSelect: onItemSelect
  }));
}

export { MultiSelect };
//# sourceMappingURL=multi-select.js.map
